import {
    Directive,
    Input
} from '@angular/core';

/**
 * Updates styles when a form group has been submitted
 * Styles target using the [formGroup] attribute.
 */
@Directive({
    selector: '[ihdFormSubmitted]',
    host: {
        '[class.is-submitted]': 'submitted === true'
    }
})
export class FormSubmittedComponent {

    @Input('ihdFormSubmitted') public submitted: boolean = false;

    constructor() {
    }
}
